<mat-form-field appearance="fill" class="data-protection-rule-select"> 
    <mat-label>{{'data protection rule' | translate:['tmc-yard.entity.transport.masterdata.dataProtectionRule', translationService.language]}}</mat-label>
    <mat-select [formControl]="formControl" [required]="required">
        <mat-option *ngFor="let rule of dataProtectionRules" [value]="rule.id">
            {{rule.name}}
        </mat-option>
    </mat-select>
</mat-form-field>